import { render } from "./InstallApp.vue?vue&type=template&id=7bc22ef0&scoped=true"
import script from "./InstallApp.vue?vue&type=script&lang=js"
export * from "./InstallApp.vue?vue&type=script&lang=js"

import "./InstallApp.vue?vue&type=style&index=0&id=7bc22ef0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc22ef0"]])

export default __exports__